import { Text } from "../../../../components/Text";
import { ItemProps } from "../types";
import { useItemHeadingText } from "./utils";

export function BaseItemHeading(props: ItemProps) {
  const { index, label, minItems, uischema } = props;
  const heading = useItemHeadingText(
    index,
    label,
    minItems,
    uischema,
    props.path
  );

  if (heading) {
    return <Text style="form/section-heading">{heading}</Text>;
  }
}
